// app/javascript/projects/components/FiltersDropdown.jsx

import React, { useState, useEffect, useRef } from 'react';
import { ButtonToolbar, Button, Checkbox, useModalContainer } from 'ui';
import ColorConstants from 'constants/ColorConstants'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import FilterCodeForm from './FilterCodeForm'
import CodeOpComponent from './analysis/CodeOpComponent'
import FilterButton from './analysis/FilterButton'
import { Scrollbars } from 'react-custom-scrollbars';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {
  OP_DEFAULT
} from 'constants/OpConstants'

var _ = require('underscore')


const dropDownStyle = {
  position: "relative",
  display: "inlineBlock",
}

const getDropDownContentStyle = (large) => ({
  borderColor: ColorConstants.LIGHT_GREY,
  backgroundColor: "white",
  minWidth: "160px",
  width: "577px",
  maxHeight: large ? undefined : "500px",
  height: large ? '70vh' : undefined,
  boxShadow: "2px 2px 2px 2px rgba(0,0,0,0.1)",
  borderRadius: "3px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
})

const FiltersDropdown = (props) => {
  const [shown, setShown] = useState(false);
  const [searchText, setSearchText] = useState("");
  const buttonRef = useRef(null);
  // Inside a ui Modal the popper must portal into the dialog's popup, not
  // <body> — see useModalContainer in ui/Modal.jsx.
  const modalContainer = useModalContainer();

  // Support for disabled codes (e.g., the main code in Code Modal)
  const disabledIds = props.disabledIds || [];

  // Handle defaultOpen prop changes (e.g., when filter is newly added)
  // Use useEffect to wait for ref to be set before opening
  useEffect(() => {
    if (props.defaultOpen && buttonRef.current) {
      setShown(true);
    }
  }, [props.defaultOpen]);

  const handleClickAway = (event) => {
    // Don't close if clicking on the button itself (toggle handles that)
    if (buttonRef.current && buttonRef.current.contains(event.target)) {
      return;
    }
    setShown(false);
  };

  const onClick = (e) => {
    setShown(!shown);
  };

  const onDoneButton = (e) => {
    setShown(false);
    if (props.applyFilter) props.applyFilter();
  };

  const filterText = (text) => {
    setSearchText(text);
  };

  const onChecked = (codeID, checked) => {
    // Don't allow toggling disabled codes
    if (codeID && !disabledIds.includes(codeID)) {
      filterText("");
      props.onChecked(codeID, checked);
    }
  };

  const getCodeName = (code) => {
    if (code.count > 0)
      return code.name + " (" + code.count + ")";
    else
      return code.name;
  };

  const createCheckboxFromCodes = (codes) => {
    const lowerSearchText = searchText.toLowerCase();
    return (codes || []).map((code, index) => {
      const included = (code?.name || '').toLowerCase().includes(lowerSearchText);
      const marginLeft = code.level > 1 ? (code.level - 1) * 30 : 0;
      const isDisabled = disabledIds.includes(code?.id);

      // Show disabled codes as plain text without checkbox
      if (isDisabled) {
        return (
          <div key={code.id}>
            {included &&
              <div style={{ marginLeft: marginLeft, padding: '5px 0', color: '#999' }}>
                {getCodeName(code)}
              </div>
            }
          </div>
        );
      }

      return (
        <div key={code.id}>
          {included &&
            <div style={{ marginLeft: marginLeft }}>
              <Checkbox
                checked={!!code.checked}
                onChange={() => onChecked(code?.id, code.checked)}
              >
                {getCodeName(code)}
              </Checkbox>
            </div>
          }
        </div>
      );
    });
  };

  let firstChecklist = [];
  let secondChecklist = [];

  if (props.codes) {
    const codes = props.codes;
    const codeLength = codes.length;
    const middle = (codeLength + 1) / 2;
    const firstCodes = codes.slice(0, middle);
    const secondCodes = codes.slice(middle, codeLength);
    firstChecklist = createCheckboxFromCodes(firstCodes);
    secondChecklist = createCheckboxFromCodes(secondCodes);
  }

  const placement = props.dropdownAbove ? 'top-start' : 'bottom-start';

  return (
    <div style={{ minWidth: 0 }}>
      <div style={dropDownStyle} ref={buttonRef}>
        <FilterButton
          op={props.op || OP_DEFAULT}
          filters={props.checkedCodeNames}
          name={props.name}
          onClick={onClick}
          maxWidth={props.maxWidth}
        />
      </div>
      <Popper
        open={shown && Boolean(buttonRef.current)}
        anchorEl={buttonRef.current}
        container={modalContainer}
        placement={placement}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 40],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
              },
            },
          ],
        }}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <div style={getDropDownContentStyle(props.large)} className='filter-dropdown-content'>
            <div style={{paddingLeft:"32px", paddingRight:"32px", width:"100%", height:"100%", display:"flex", flexDirection:"column"}}>

              <div style={{width:"100%", paddingTop:"20px", flexShrink: 0}}>
                <FilterCodeForm
                  filterText={filterText}
                  searchText={searchText}
                  placeholder="Search Codes"
                  />
              </div>

              <div style={{
                  color:ColorConstants.LIGHT_GREY,
                  clear:"both",
                  display:"block",
                  paddingTop: "10px",
                  flexShrink: 0
                }}>
                <CodeOpComponent
                  op={props.op}
                  anyClick={props.anyClick}
                  allClick={props.allClick}
                  text={props.subHeader}
                />
              </div>

              <Scrollbars autoHide style={{width: "100%", flex: "1 1 auto", marginTop: "10px", minHeight: 200}}>
                <div style={{clear:"both", display:"block"}}>
                  <div style={{width: "50%", float:"left"}}>
                    {firstChecklist}
                  </div>

                  <div style={{width: "50%", float:"right"}}>
                    {secondChecklist}
                  </div>
                </div>
              </Scrollbars>
              <div style={{width: "100%", display: "flex", justifyContent: "flex-end", paddingBottom: 20, paddingTop: 20, flexShrink: 0}}>
                <ButtonToolbar>
                  {props.onDeleteFilter && (
                    <Button variant="link" onClick={props.onDeleteFilter}>
                      <DeleteOutlineIcon data-testid="DeleteOutlinedIcon" style={{ fontSize: 16 }} />
                    </Button>
                  )}
                  <Button variant="white" onClick={props.onClearChecked}>Clear</Button>
                  <Button variant="blue" onClick={onDoneButton}>
                    {props.filterButtonText || "Apply Filters"}
                  </Button>
                </ButtonToolbar>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default FiltersDropdown;
